module.exports = __webpack_public_path__ + "assets/img/ed0536cefdf70ac28ae41ce53112b792.svg";